import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f753a7fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-md-h4 text-h5 libre_basker text-shadow text-white px-5 d-none d-sm-flex" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "libre_basker" }, "Nolan Sparkle & Shine")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo d-flex d-sm-none",
  src: "/icons/android-chrome-96x96-light.png"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Home ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Services ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" About Us ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Contact Us ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_btn_group = _resolveComponent("v-btn-group")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createBlock(_component_v_app_bar, {
    elevation: "1",
    style: {"position":"fixed"},
    class: _normalizeClass({
      transparent: _ctx.windowTop < 1,
    })
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      (!_ctx.display.smAndDown)
        ? (_openBlock(), _createBlock(_component_v_spacer, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_app_bar_nav_icon, {
        onClick: _ctx.toggleDraw,
        class: "d-flex d-sm-none",
        icon: this.$store.state.navdraw ? 'mdi-menu-open' : 'mdi-menu',
        color: "white"
      }, null, 8, ["onClick", "icon"]),
      _createVNode(_component_v_spacer, { class: "d-flex d-sm-none" }),
      _hoisted_2,
      _createVNode(_component_v_btn_group, { class: "d-none d-sm-flex" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            onClick: _ctx.goto_home,
            color: "white"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_v_menu, {
            modelValue: _ctx.serviceMenu,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.serviceMenu) = $event))
          }, {
            activator: _withCtx(({ props }) => [
              _createVNode(_component_v_btn, _mergeProps(props, { color: "white" }), {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 2
              }, 1040)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_list, { elevation: "10" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.$store.getters['services/allServices'], (item, index) => {
                    return (_openBlock(), _createBlock(_component_v_list_item, {
                      key: index,
                      onClick: ($event: any) => (_ctx.goto_services(item.id)),
                      color: "white"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.name), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_v_btn, { onClick: _ctx.goto_about }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_v_btn, { onClick: _ctx.goto_contact }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["class"]))
}